/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { Link } from 'react-router-dom';
import { FaHome, FaSearch, FaTools, FaExclamationTriangle } from 'react-icons/fa';
import Nav from '../components/layout/Nav';
import Footer from '../components/layout/Footer';
import '../styles/notfound.scss';

const NotFoundPage = () => {
  return (
    <div className="not-found-page">
      <Nav />

      {/* Hero Section */}
      <section className="not-found-hero">
        <div className="container">
          <div className="not-found-content">
            {/* Animated 404 Number */}
            <div className="error-code">
              <span className="number-4">4</span>
              <div className="tool-icon">
                <FaTools />
              </div>
              <span className="number-4">4</span>
            </div>

            {/* Main Message */}
            <div className="error-message">
              {/* <h1>Page Under Construction</h1> */}
              <p className="subtitle">
                Oops! It looks like this page isn't ready yet or doesn't exist.
                <br />
         
              </p>
            </div>

            {/* Action Buttons */}
            {/* <div className="action-buttons">
              <Link to="/" className="btn-primary">
                <FaHome /> Back to Home
              </Link>
              <Link to="/artisans" className="btn-secondary">
                <FaTools /> Browse Artisans
              </Link>
              <button 
                className="btn-ghost"
                onClick={() => window.history.back()}
              >
                ← Go Back
              </button>
            </div> */}

            {/* Search Bar */}
            {/* <div className="search-suggestion">
              <p>Or try searching for what you need:</p>
              <form className="search-box" onSubmit={(e) => e.preventDefault()}>
                <input 
                  type="text" 
                  placeholder="Search for services, artisans, or projects..."
                  onKeyPress={(e) => {
                    if (e.key === 'Enter') {
                      window.location.href = `/search?q=${e.target.value}`;
                    }
                  }}
                />
                <button type="submit">
                  <FaSearch />
                </button>
              </form>
            </div> */}

            {/* Popular Services Quick Links */}
            {/* <div className="quick-links">
              <h3>Popular Services You Might Like:</h3>
              <div className="services-grid">
                <Link to="/services/carpentry" className="service-card">
                  <div className="service-icon">🔨</div>
                  <span>Carpentry</span>
                </Link>
                <Link to="/services/plumbing" className="service-card">
                  <div className="service-icon">🚰</div>
                  <span>Plumbing</span>
                </Link>
                <Link to="/services/electrician" className="service-card">
                  <div className="service-icon">⚡</div>
                  <span>Electrical</span>
                </Link>
                <Link to="/services/painting" className="service-card">
                  <div className="service-icon">🎨</div>
                  <span>Painting</span>
                </Link>
                <Link to="/services/masonry" className="service-card">
                  <div className="service-icon">🧱</div>
                  <span>Masonry</span>
                </Link>
                <Link to="/services/design" className="service-card">
                  <div className="service-icon">📐</div>
                  <span>Design</span>
                </Link>
              </div>
            </div> */}

            {/* Help Section */}
            <div className="help-section">
              <div className="help-alert">
                <FaExclamationTriangle className="alert-icon" />
                <div className="alert-content">
                  <h4>Can't find what you're looking for?</h4>
                  <p>
                    Contact our support team at{' '}
                    <a href="mailto:artizakenya@gmail.com">artizakenya@gmail.com</a>
                    {' '}or call <a href="tel:+254700000000">+254 700 000 000</a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default NotFoundPage;